// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__UiLj-","input_btn":"input_input_btn__2pjHq","input_inpt":"input_input_inpt__3UwPG","btn":"input_btn__2QmxG"};